// Small facts about the phone that change what the page offers. Pure functions of what the browser reports, so they can be tested.

/**
 * An iPhone, iPad or iPod, in Safari or in any in-app browser on iOS (all of them are WebKit). iPadOS 13 and later reports itself as a Mac, so a
 * "Mac" with a touch screen is an iPad.
 */
export function isIos(userAgent: string, platform: string, maxTouchPoints: number): boolean {
  return /iPhone|iPad|iPod/.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1)
}

export function runsOnIos(): boolean {
  return isIos(navigator.userAgent, navigator.platform, navigator.maxTouchPoints)
}

/**
 * Guests are told "no app needed", so the browser must not offer to install one. The automatic prompt is suppressed and no install button is
 * ever shown on a guest page. (The pages also carry no web app manifest, which is what makes a browser consider offering it at all; this is the
 * second lock on the same door.)
 */
export function blockInstallPrompt(target: Pick<Window, 'addEventListener'> = window): void {
  target.addEventListener('beforeinstallprompt', (e) => e.preventDefault())
}
